import { z } from 'zod';

export const NativeAdoptionSchema = z
  .object({
    windowDays: z.number().int().min(1).max(90),
    minBuildCode: z
      .number()
      .int()
      .positive()
      .max(Number.MAX_SAFE_INTEGER)
      .optional(),
    minNativeVersionName: z
      .string()
      .regex(/^\d+\.\d+\.\d+$/, '請輸入實際原生版本，例如 2.0.130')
      .optional(),
  })
  .superRefine((v, ctx) => {
    if (
      (v.minBuildCode !== undefined) ===
      (v.minNativeVersionName !== undefined)
    ) {
      for (const name of ['minBuildCode', 'minNativeVersionName']) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: [name],
          message: '請填寫一種實際原生版本門檻',
        });
      }
    }
  });
export type NativeAdoptionValues = z.infer<typeof NativeAdoptionSchema>;
